import { $can } from '@pendo/permissions';

function checkPermission (appId, action, entity = 'guide', source = 'ANY', target = 'ANY') {
    if (!appId || !action) {
        return false;
    }

    return $can(appId)
        .entity(entity)
        .action(action)
        .source(source)
        .target(target);
}

export function canCreateEmail ({ appId, entity, source, target }) {
    return checkPermission(appId, 'create', entity, source, target);
}

export function canUpdateEmail ({ appId, entity, source, target, email }) {
    if (!source && email?.status === 'public') {
        source = 'public';
    }

    return checkPermission(appId, 'edit', entity, source, target);
}

export function canDeleteEmail ({ appId, entity, source, target, email }) {
    if (!source && email?.status === 'public') {
        source = 'public';
    }

    return checkPermission(appId, 'remove', entity, source, target);
}

export function canPublishEmail ({ appId, entity, source, target }) {
    return checkPermission(appId, 'publish', entity, source, target);
}
